import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatTooltip } from "@angular/material/tooltip";
import { RouterLink } from "@angular/router";
import { QuicklinkModule } from "ngx-quicklink";
import { PopupNotificationsComponent } from "src/app/components/popup-notifications/popup-notifications.component";
import { SearchModulesComponent } from "src/app/components/search-modules/search-modules.component";
import { PAGE_URLS } from "src/app/core/models/general";
import { AppNotificationService } from "src/app/core/services/app-notification.service";
import { ColorModeService } from "src/app/core/services/color-mode.service";
import { PopupNotificationService } from "src/app/core/services/popup-notification.service";
import { AppService } from "src/services/app.service";
import { AdminService } from "./../../modules/admins/services/admin.service";
import { CommunicationService } from "src/app/core/services/communication.service";
import { BroadcastMessages } from "src/app/shared/general/constants";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
  imports: [
    MatProgressBar,
    RouterLink,
    QuicklinkModule,
    FormsModule,
    SearchModulesComponent,
    MatTooltip,
    PopupNotificationsComponent,
  ],
})
export class HeaderComponent implements OnInit {
  isProgressBarLoading = this.appNotificationService.getIsProgressBarLoading;
  private isModuleSearchVisible = false;
  hasUnreadPopupNotifications = false;
  isNotificationsVisible = false;
  PAGE_URLS = PAGE_URLS;

  get menuImage() {
    return this.isSideNavBarVisible
      ? "/assets/icons/close.svg"
      : "/assets/icons/bars.svg";
  }

  get isSideNavBarVisible() {
    return this.appService.getIsSideNavBarVisible();
  }

  get colorModeImage() {
    if (this.colorModeService.isDarkMode) {
      return "/assets/icons/svg/dark/light.svg";
    }
    return "/assets/icons/svg/colored/dark.svg";
  }

  get notificationsImage() {
    if (this.colorModeService.isDarkMode) {
      return "/assets/icons/svg/dark/bell.svg";
    }
    return "/assets/icons/svg/colored/bell.svg";
  }

  get switchColorModeMessage() {
    if (this.colorModeService.isDarkMode) {
      return "Switch to Light Mode";
    }
    return "Switch to Dark Mode";
  }

  constructor(
    private popupNotificationService: PopupNotificationService,
    private appNotificationService: AppNotificationService,
    private communicationService: CommunicationService,
    private colorModeService: ColorModeService,
    private adminService: AdminService,
    private appService: AppService,
  ) {}

  ngOnInit(): void {
    this.popupNotificationService
      .getPopupNotifications()
      .subscribe((notifications) => {
        if (notifications.length === 0) {
          this.hasUnreadPopupNotifications = false;
        } else {
          this.hasUnreadPopupNotifications =
            this.popupNotificationService.hasUnreadPopupNotifications();
        }
      });
  }

  toggleSideNavBar(event: MouseEvent) {
    event.stopPropagation();
    this.appService.setIsSideNavBarVisible(!this.isSideNavBarVisible);
  }

  toggleNotifications(event: MouseEvent) {
    event.stopPropagation();
    this.isNotificationsVisible = !this.isNotificationsVisible;
  }

  setIsModuleSearchVisible(isModuleSearchVisible: boolean) {
    this.isModuleSearchVisible = isModuleSearchVisible;
  }

  getIsModuleSearchVisible() {
    return this.isModuleSearchVisible;
  }

  getAdminProfilePicture() {
    return this.adminService.getAdminProfilePicture();
  }

  showModuleSearch(event: MouseEvent) {
    event.stopPropagation();
    this.setIsModuleSearchVisible(true);
  }

  changeColorMode() {
    this.colorModeService.changeColorMode();
    this.communicationService.sendMessage({
      type: BroadcastMessages.COLOR_MODE_UPDATED,
      data: this.colorModeService.currentMode,
    });
  }
}
